import React from "react"

import BaseTable from "./BaseTable"

import moment from "moment"

import {Link} from "react-router-dom"

import AddCompanyModal from "../modal/AddCompanyModal";
import ConfirmationModal from "../modal/ConfirmationModal";

import DeleteCell from "./cells/DeleteCell";
import RecurringCell from "./cells/RecurringCell";
import PillCell from "./cells/PillCell";
import CustomerCell from "./cells/CustomerCell";
import ExpanderCell from "./cells/ExpanderCell";
import DownloadCell from "./cells/DownloadCell";
import SendCell from "./cells/SendCell";
import PaymentProcessedCell from './cells/PaymentProcessedCell'
import PaymentFeeCell from './cells/PaymentFeeCell'
import PaymentNetCell from './cells/PaymentNetCell'

import DisplayCDC from "../splink/DisplayCDC";

import Notify from "../../../utils/Notify";
import Backend from '../../../utils/Backend'
import General from '../../../utils/General'
import Currency from "../../../utils/Currency";
import AuthManager from '../../../utils/AuthManager'
import ViewCell from "./cells/ViewCell";


const TYPE_FILTERS = {
  name: {
    api: "recurring",
    display: "recurring"
  },
  values: [{
    label: "All Payments",
    value: null
  },
    {
      label: "Recurring",
      value: "true"
    },
    {
      label: "One-Off",
      value: "false"
    }]
}

const STATUS_FILTERS = {
  name: {
    api: "type",
    display: "type"
  },
  values: [
    {
      label: "All Add-Ons",
      value: null
    },
    {
      label: "Take",
      value: "take"
    },
    {
      label: "Request",
      value: "payment_request"
    },
    {
      label: "Shop",
      value: "shop"
    },
    {
      label: "POS",
      value: "pos"
    },
    {
      label: "SoftPOS",
      value: "soft_pos"
    }
  ]
}

const FILTERS = [
  TYPE_FILTERS,
  STATUS_FILTERS
]

export default class PaymentsTable extends React.Component {

  constructor(props){
    super(props)

    this.state = {
      dateFrom: props.dateFrom,
      dateTo: props.dateTo,
      company: props.company,
      payout: props.payout,
    }

    this.table = React.createRef()
  }

  componentWillReceiveProps(nextProps){
    this.setState(nextProps, () => this._refresh())
  }

  _refresh(){
    this.table.current.refresh()
  }

  _getColumns() {
    let columns = [
      {
        expander: true,
        Expander: ({ isExpanded, ...props }) => (
          <ExpanderCell
            isExpanded={isExpanded}
            show={() => {
              let payment = props.original
              let customer = payment.customer
              let showExpander = this.props.payout || customer.shipping_address || customer.note || payment.answers.length > 0
              return showExpander || true // always show expander due to charge id
            }}
          />
        )
      },
      {
        Header: 'Company',
        id: 'company.name',
        accessor: 'company.name',
        width: 160
      }
    ]

    if(AuthManager.isPlatformAdmin()){
      columns.push({
        Header: 'Partner',
        id: 'company.association.name',
        sortable: true,
        exportable: true,
        accessor:  payment => payment.company.association?.name || "-"
      })
    }

    columns = [
      ...columns,
      {
        Header: 'Name',
        id: 'customer.first_name',
        Cell: rowInfo => {
          let payment = rowInfo.original
          return (
            <CustomerCell
              customer={payment.customer}
            />
          )
        },
        width: 160
      },
    ]

    if (!this.props.payout) {
      columns = [
        ...columns,
        {
          Header: 'Amount',
          id: 'payment_plan.total',
          accessor:  payment => Currency.format(payment.payment_plan.currency.symbol, payment.payment_plan.total)
        },
      ]
    }

    if (this.props.payout) {
      columns = [
        ...columns,
        {
          Header: 'Processed',
          sortable: false,
          id: 'payment_plan.total',
          Cell: (rowInfo) => {
            let payment = rowInfo.original

            return (
              <PaymentProcessedCell
                payment={payment}
                payout={this.props.payout}
              />
            )
          },
        },
        {
          Header: 'Fees',
          sortable: false,
          id: 'fee',
          Cell: (rowInfo) => {
            let payment = rowInfo.original

            return (
              <PaymentFeeCell payment={payment} payout={this.props.payout} />
            )
          },
        },
        {
          Header: 'Deposited',
          sortable: false,
          id: 'commission',
          Cell: (rowInfo) => {
            let payment = rowInfo.original

            return (
              <PaymentNetCell payment={payment} payout={this.props.payout} />
            )
          },
        },
      ]
    }

    columns = [
      ...columns,
      {
        Header: 'Type',
        id: 'type',
        exportable: false,
        Cell: rowInfo => {
          let payment = rowInfo.original
          let paymentMethodType = payment.payment_instrument?.payment_method?.type
          let takeTitle = paymentMethodType === "pos" ? "POS" : paymentMethodType === "soft_pos" ? "SoftPOS" : paymentMethodType === "cash" ? "Cash" : "Take"
          let text = payment.payment_plan.product
            ? 'Shop'
            : payment.payment_plan.payment_request
              ? 'Request'
              : takeTitle
          let className = payment.payment_plan.product
            ? 'label-light-info'
            : payment.payment_plan.payment_request
              ? 'label-light-danger'
              : 'label-light-primary'
          return (
            <PillCell
              text={text}
              className={className}
            />
          )
        }
      },
      {
        Header: 'Recurring',
        id: 'subscription',
        sortable: false,
        exportable: false,
        Cell: rowInfo => {
          let payment = rowInfo.original
          if(payment.subscription || payment.processor_payment_data.subscription_id){
            return <RecurringCell/>
          }
          return null
        }
      },
      {
        Header: 'Status',
        id: 'status',
        Cell: (rowInfo) => {
          let payment = rowInfo.original
          let className = 'label-light-success'
          let text = General.snakeCaseToTitleCase(payment.status)
          if(payment.status === "pending"){
            className = 'label-light-info'
          }
          else if(payment.status === "failed"){
            className = 'label-light-danger'
          }
          if(payment.refunded_at){
            text = General.snakeCaseToTitleCase(payment.refund_status || "Refunded")
            className = 'label-light-warning'
          }
          return <PillCell text={text} className={className} />
        },
      },
      {
        Header: 'Date Paid',
        id: 'paid_at',
        accessor: payment => moment(payment.paid_at).format('DD MMM YYYY HH:mm') || '-'
      },
      {
        Header: 'Refund Date',
        id: 'deleted_at',
        accessor: payment => payment.deleted_at ? moment(payment.deleted_at).format('DD MMM YYYY') : '-'
      },
    ]

    if (!this.props.payout) {
      columns = [
        ...columns,
        {
          Header: 'Actions',
          id: 'status',
          width: 150,
          sortable: false,
          exportable: false,
          Cell: rowInfo => {
            let payment = rowInfo.original
            return (
              <span style={{overflow: 'visible', position: 'relative', width: 150}}>
              {payment.file && (
                <DownloadCell
                  tooltip={'Download Receipt'}
                  onDownloadClicked={() => {
                    window.open(payment.file.url, '_blank')
                  }}
                />
              )}
                <SendCell
                  tooltip={"Resend Receipt"}
                  onSendClicked={() => {
                    this.setState({
                      paymentToResend: payment,
                      showConfirmationModal: true
                    })
                  }}
                />
            </span>
            )
          }
        }
      ]
    }

    return columns
  }

  _resendReceipt(){
    let {
      paymentToResend
    } = this.state

    Backend.resendPaymentReceipt(paymentToResend).then(() => {
      Notify.success("Receipt has been resent successfully.")
      this.setState({
        paymentToResend: null,
        showConfirmationModal: false
      })
      this.table.current.refresh()
    }).catch(e => {
      Notify.error(e.message)
      this.setState({
        paymentToResend: null,
        showConfirmationModal: false
      })
    })
  }

  _renderToolBar(){
    if (this.props.payout) {
      return null
    }
    if(this.props.latestResults){
      return (
        <Link to="/payments" className="btn btn-light-primary font-weight-bolder ml-4">
          <span className="svg-icon svg-icon-md">
            <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="24px" height="24px"
               viewBox="0 0 24 24" version="1.1">
              <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <rect x="0" y="0" width="24" height="24"></rect>
                <rect fill="#000000" opacity="0.3" x="2" y="5" width="20" height="14" rx="2"></rect>
                <rect fill="#000000" x="2" y="8" width="20" height="3"></rect>
                <rect fill="#000000" opacity="0.3" x="16" y="14" width="4" height="2" rx="1"></rect>
              </g>
            </svg>
          </span>
          View All Payments
        </Link>
      )
    }

    return (
      <>

      </>
    )
  }

  _renderConfirmationModal(){
    let {
      paymentToResend,
      showConfirmationModal
    } = this.state

    let message = ""
    if(paymentToResend){
      message = "Are you sure you want to resend the receipt for this payment?"
    }

    return (
      <ConfirmationModal
        show={showConfirmationModal}
        title={message}
        onConfirm={() => {
          if(paymentToResend){
            this._resendReceipt()
          }
        }}
        onHide={() => {
          this.setState({
            payment: null,
            showConfirmationModal: false
          })
        }}
      />
    )
  }

  _renderDescription(payment){
    const {
      payment_instrument: paymentInstrument,
      transaction_details: transactionDetails,
      processor_payment_data,
      processor_payment_id,
      processor_payment_status,
      status,
      customer,
      payment_plan: paymentPlan,
      products,
      answers,
      fees_synced,
      fees,
      net
    } = payment

    const paymentMethod = paymentInstrument?.payment_method

    const Detail = ({ label, children }) => (
      <p className="mb-0" style={{whiteSpace: "pre-wrap"}}>
        <b>{label}:</b> {children}
      </p>
    )

    const Section = ({ title, children }) => (
      <div className="mb-3">
        <h6>{title}</h6>
        {children}
      </div>
    )

    const shippingAddress = customer?.shipping_address

    const formatAddress = (address) => [address.line_1, address.line_2, address.city, address.state, address.country,].filter(Boolean).join(', ')

    const feeDetails = [
      ['Commission', Currency.format(paymentPlan.currency.symbol, fees?.commission)],
      ['Scheme', Currency.format(paymentPlan.currency.symbol, fees?.scheme)],
      ['Interchange', Currency.format(paymentPlan.currency.symbol, fees?.interchange)],
      ['Total', Currency.format(paymentPlan.currency.symbol, fees?.total)],
    ]

    const transactionDetailsList = [
      ['Category', transactionDetails?.category],
      ['Card Type', transactionDetails?.card_type],
      ['Card Region', transactionDetails?.card_region],
      ['Funding Source', transactionDetails?.funding_source],
      ['Shopper Interaction', transactionDetails?.shopper_interaction],
    ]

    const cardDetails = [
      ['Brand', paymentInstrument?.brand],
      ['Variant', paymentInstrument?.variant],
      ['Identifier', paymentInstrument?.identifier],
      ['Cardholder Name', paymentInstrument?.cardholder_name],
      ['Expiry', (paymentInstrument?.expiry_mm && paymentInstrument?.expiry_yy) ? `${paymentInstrument?.expiry_mm}/${paymentInstrument?.expiry_yy}` : ""],
    ]

    return (
      <div style={{backgroundColor: '#fff', paddingTop: 15, paddingLeft: 15}}>
        {processor_payment_data && (
          <p className="mb-3">
            <b>ID:</b> {processor_payment_id}
          </p>
        )}

        {/*{transactionDetails && (*/}
        {/*  <Section title="Transaction Details">*/}
        {/*    {transactionDetailsList.map(([label, value]) => (*/}
        {/*      <Detail key={label} label={label}>*/}
        {/*        {value}*/}
        {/*      </Detail>*/}
        {/*    ))}*/}
        {/*  </Section>*/}
        {/*)}*/}

        {status !== 'completed' && (
          <p className="mb-3" style={{whiteSpace: "pre-wrap"}}>
            <b>Processor Payment Status:</b> {processor_payment_status}
          </p>
        )}

        {
          shippingAddress && (
          <p className="mb-3" style={{whiteSpace: "pre-wrap"}}>
            <b>Customer Address:</b> {formatAddress(shippingAddress)}
          </p>
        )}

        {
          customer?.note && (
          <p className="mb-3" style={{whiteSpace: "pre-wrap"}}>
            <b>Customer Note: </b>
            {customer.note}
          </p>
        )}

        {
          paymentPlan?.payment_link && (
          <p className="mb-3" style={{whiteSpace: "pre-wrap"}}>
            <b>Channel: </b>
            {paymentPlan.payment_link.title}
          </p>
        )}

        {
          (products.length === 0 && answers.length > 0) && (
          <DisplayCDC answers={answers} />
        )}

        {products.length > 0 && (
          <>
            <h5>Products</h5>

            {
              products.map((product) => {
                const total = product.product_total * product.quantity

                const price = Currency.format(paymentPlan.currency.symbol, total)

                const unitPrice = Currency.format(paymentPlan.currency.symbol, product.product_total)

                const name = product.quantity > 1 ? `${product.quantity}x ${product.name}` : product.name

                const formattedPrice = product.quantity > 1 ? `${price} (${unitPrice} each)` : price

                return (
                  <div key={product.id} className="mb-3">
                    <hr />
                    <p>
                      <b>Product: </b>
                      { name }
                    </p>
                    <p>
                      <b>Price: </b>
                      { formattedPrice }
                    </p>
                    <DisplayCDC answers={product.answers} />
                  </div>
                )
              })
            }
          </>
        )}

        {
          fees_synced &&
          <p className="mb-3">
            <b>Net:</b> {Currency.format(paymentPlan.currency.symbol, net)}
          </p>
        }

        {fees_synced && fees && (
          <Section title="Fees">
            {feeDetails.map(([label, value]) => (
              <Detail key={label} label={label}>
                {value || "-"}
              </Detail>
            ))}
          </Section>
        )}

        {(["card", "pos", "soft_pos"].includes(paymentMethod?.type)) && (
          <Section title="Card Details">
            {cardDetails.map(([label, value]) => (
              <Detail key={label} label={label}>
                {value || "-"}
              </Detail>
            ))}
          </Section>
        )}
      </div>
    )
  }

  render() {
    let {
      dateFrom,
      dateTo,
      company,
      payout
    } = this.state

    const columns = this._getColumns()

    const filters = this.props.latestResults || payout ? null : FILTERS

    return (
      <div>
        <BaseTable
          ref={this.table}
          endpoint={`${window.Api.Payments}?min_date=${dateFrom?.format('YYYY-MM-DD') || ''}&max_date=${dateTo?.format('YYYY-MM-DD') || ''}&company_id=${company?.id || ""}&payout_id=${payout?.id || ''}`}
          noDataMessage={"No payment found"}
          deletedObjectLabel="Refunded"
          title={this.props.title}
          columns={columns}
          showExport={false}
          filters={filters}
          defaultSorted={[
            {
              id: "paid_at",
              desc: true
            }
          ]}
          showSearch={!this.props.latestResults}
          showPaginationBottom={!this.props.latestResults}
          SubComponent={row => this._renderDescription(row.original)}
          renderToolbar={() => this._renderToolBar()}
          showHeader={this.props.showHeader !== undefined ? this.props.showHeader : true}
        />
        { this._renderConfirmationModal() }
      </div>
    )
  }
}

PaymentsTable.defaultProps = {
  latestResults: false
}
